var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcViaaerea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 36H9L12 32C13.2 30.4 12.8333 27.3333 12.5 26L12 15L22.5 7.99999C24.1667 7.66666 27.6 7.29999 28 8.49999L29.5 13L29 14.5C29.1667 15 29.7 16.3 30.5 17.5C31.3 18.7 31.5 20 31.5 20.5L29 21L30 24C29.5 24.3333 28.6 25.2 29 26C29.4 26.8 28.5 28 28 28.5H25.5C23.5 28.5 23.5 29 23.5 31C23.5 32.6 25.5 35 26.5 36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7407 25.9259V30.0741C12.7407 31.6266 10.3526 33.9259 9.18518 36",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 21.1852C15.4074 21.1852 14.5185 19.443 14.5185 17.6296C14.5185 16.1956 14.963 14.6667 16.2963 14.6667C17.6296 14.6667 17.5822 16.4444 19.2593 16.4444C20.9363 16.4444 20.1481 12.557 22.5896 10.5185C23.9585 9.38074 28.7407 9.92593 28.7407 6.37037C28.7407 4.74074 26.8148 4 19.2593 4C11.7037 4 8 4.52148 8 14.0741C8 22.9274 11.7393 25.9259 12.7407 25.9259C13.3333 25.9259 14.5185 25.3333 14.5185 23.5556C14.5185 22.5541 13.1852 20.2252 14.5185 17.6296",
    fill: "#F5FBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 21.1852C15.4074 21.1852 14.5185 19.443 14.5185 17.6296M14.5185 17.6296C14.5185 16.1956 14.963 14.6667 16.2963 14.6667C17.6296 14.6667 17.5822 16.4444 19.2593 16.4444C20.9363 16.4444 20.1481 12.557 22.5896 10.5185C23.9585 9.38074 28.7407 9.92593 28.7407 6.37037C28.7407 4.74074 26.8148 4 19.2593 4C11.7037 4 8 4.52148 8 14.0741C8 22.9274 11.7393 25.9259 12.7407 25.9259C13.3333 25.9259 14.5185 25.3333 14.5185 23.5556C14.5185 22.5541 13.1852 20.2252 14.5185 17.6296Z",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2311 8.14813C28.2193 10.1867 29.2563 12.0711 29.3333 12.96C29.4104 13.8489 28.9244 14.1807 29.037 14.9629C29.1496 15.7392 31.7037 19.04 31.7037 20C31.7037 20.96 29.3333 21.1496 29.3333 21.1496C29.3333 22.56 29.6652 22.8859 29.6652 23.52C29.6652 23.9289 29.1496 24.2074 29.1496 24.2074C29.1496 24.2074 29.4104 24.3733 29.4104 25.0015C29.4104 25.3452 28.7467 25.8015 28.7467 25.8015C28.7467 25.8015 29.043 27.2237 28.9304 27.8163C28.8178 28.4089 28.4504 28.8533 26.8563 28.8533C25.2622 28.8533 23.4133 28.397 23.4133 30.6667V31.8163C23.4133 32.6044 23.7215 33.357 24.2667 33.92C25.1141 34.7911 26.3052 36 26.3763 36",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5555 22.963C19.8518 22.963 17.4814 22.963 17.4814 36",
    stroke: "#F9839A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9629 25.3333C21.037 25.3333 21.037 25.9259 21.037 36",
    stroke: "#F9839A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViaaerea);
export default __webpack_public_path__ + "static/media/Ic_via aerea.08a04be62253b37386d7e4f7c33f3645.svg";
export { ForwardRef as ReactComponent };